(function () {
  var WIDGET_ID = 'promos';
  var OPEN_EVENT = 'rechilero:floating-panel-open';

  function init() {
    var root = document.querySelector('[data-floating-promos]');
    if (!root || root.dataset.fpInit) return;
    root.dataset.fpInit = '1';

    var toggleBtn = root.querySelector('[data-floating-promos-toggle]');
    var panel = root.querySelector('[data-floating-promos-panel]');
    var dismissBtn = root.querySelector('[data-floating-promos-dismiss]');
    if (!toggleBtn || !panel) return;

    // La burbuja es permanente -- cerrar el panel (con la "x" o afuera)
    // solo lo colapsa, nunca oculta el widget entero. El div raiz arranca
    // con "hidden" en el Liquid solo para evitar el flash-of-content
    // antes de que corra este script.
    root.hidden = false;

    var MOBILE_QUERY = '(max-width: 749px)';
    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    // En movil hay un estado extra "pegado" (docked, ver el stylesheet
    // del .liquid): solo el icono, mitad afuera de la pantalla, para no
    // interrumpir la navegacion mientras el cliente scrollea -- es el
    // estado de reposo por defecto. Un primer toque la trae a la vista
    // completa ("expanded", el boton de siempre); un segundo toque recien
    // ahi abre el panel. En escritorio este estado no existe (la burbuja
    // siempre esta en su forma completa) -- ver isMobile() en cada rama.
    root.dataset.state = isMobile() ? 'docked' : 'expanded';

    function openPanel() {
      root.dataset.state = 'expanded';
      panel.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      // Le avisa a otras burbujas flotantes (ej. Mas Vendidos) que se
      // cierren -- dos paneles abiertos a la vez en la misma esquina se
      // pisan visualmente.
      document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { id: WIDGET_ID } }));
    }

    function closePanel() {
      panel.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      // En movil, cerrar el panel vuelve al estado "pegado" de reposo en
      // vez de dejarla como boton completo -- asi vuelve a estar fuera
      // del medio apenas el cliente termina de mirarla.
      if (isMobile()) root.dataset.state = 'docked';
    }

    toggleBtn.addEventListener('click', function () {
      // Primer toque en movil, arrancando "pegada": solo se expande a
      // boton completo, todavia no abre el panel.
      if (isMobile() && root.dataset.state !== 'expanded' && panel.hidden) {
        root.dataset.state = 'expanded';
        return;
      }
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (dismissBtn) {
      dismissBtn.addEventListener('click', closePanel);
    }

    document.addEventListener(OPEN_EVENT, function (e) {
      if (e.detail && e.detail.id !== WIDGET_ID && !panel.hidden) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });

    // Un click afuera cierra el panel si estaba abierto (y en movil la
    // vuelve a dejar "pegada"); si solo estaba expandida sin panel
    // abierto (primer toque en movil sin llegar al segundo), tambien la
    // vuelve a pegar en vez de dejarla a medio camino.
    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      if (!panel.hidden) {
        closePanel();
      } else if (isMobile() && root.dataset.state === 'expanded') {
        root.dataset.state = 'docked';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
